export const countries = [
    { code: 'AD', en: 'Andorra', de: 'Andorra' },
    { code: 'AE', en: 'United Arab Emirates', de: 'Vereinigte Arabische Emirate' },
    { code: 'AF', en: 'Afghanistan', de: 'Afghanistan' },
    { code: 'AG', en: 'Antigua and Barbuda', de: 'Antigua und Barbuda' },
    { code: 'AI', en: 'Anguilla', de: 'Anguilla' },
    { code: 'AL', en: 'Albania', de: 'Albanien' },
    { code: 'AM', en: 'Armenia', de: 'Armenien' },
    { code: 'AO', en: 'Angola', de: 'Angola' },
    { code: 'AQ', en: 'Antarctica', de: 'Antarktis' },
    { code: 'AR', en: 'Argentina', de: 'Argentinien' },
    { code: 'AS', en: 'American Samoa', de: 'Amerikanisch-Samoa' },
    { code: 'AT', en: 'Austria', de: 'Österreich' },
    { code: 'AU', en: 'Australia', de: 'Australien' },
    { code: 'AW', en: 'Aruba', de: 'Aruba' },
    { code: 'AX', en: 'Åland Islands', de: 'Åland' },
    { code: 'AZ', en: 'Azerbaijan', de: 'Aserbaidschan' },
    { code: 'BA', en: 'Bosnia and Herzegovina', de: 'Bosnien und Herzegowina' },
    { code: 'BB', en: 'Barbados', de: 'Barbados' },
    { code: 'BD', en: 'Bangladesh', de: 'Bangladesch' },
    { code: 'BE', en: 'Belgium', de: 'Belgien' },
    { code: 'BF', en: 'Burkina Faso', de: 'Burkina Faso' },
    { code: 'BG', en: 'Bulgaria', de: 'Bulgarien' },
    { code: 'BH', en: 'Bahrain', de: 'Bahrain' },
    { code: 'BI', en: 'Burundi', de: 'Burundi' },
    { code: 'BJ', en: 'Benin', de: 'Benin' },
    { code: 'BL', en: 'Saint Barthélemy', de: 'Saint-Barthélemy' },
    { code: 'BM', en: 'Bermuda', de: 'Bermuda' },
    { code: 'BN', en: 'Brunei', de: 'Brunei' },
    { code: 'BO', en: 'Bolivia', de: 'Bolivien' },
    { code: 'BQ', en: 'Bonaire, Sint Eustatius and Saba', de: 'Bonaire, Sint Eustatius und Saba' },
    { code: 'BR', en: 'Brazil', de: 'Brasilien' },
    { code: 'BS', en: 'Bahamas', de: 'Bahamas' },
    { code: 'BT', en: 'Bhutan', de: 'Bhutan' },
    { code: 'BV', en: 'Bouvet Island', de: 'Bouvetinsel' },
    { code: 'BW', en: 'Botswana', de: 'Botsuana' },
    { code: 'BY', en: 'Belarus', de: 'Weißrussland' },
    { code: 'BZ', en: 'Belize', de: 'Belize' },
    { code: 'CA', en: 'Canada', de: 'Kanada' },
    { code: 'CC', en: 'Cocos (Keeling) Islands', de: 'Kokosinseln' },
    { code: 'CD', en: 'DR Congo', de: 'Kongo (Demokratische Republik)' },
    { code: 'CF', en: 'Central African Republic', de: 'Zentralafrikanische Republik' },
    { code: 'CG', en: 'Congo', de: 'Kongo' },
    { code: 'CH', en: 'Switzerland', de: 'Schweiz' },
    { code: 'CI', en: "Côte d'Ivoire", de: 'Elfenbeinküste' },
    { code: 'CK', en: 'Cook Islands', de: 'Cookinseln' },
    { code: 'CL', en: 'Chile', de: 'Chile' },
    { code: 'CM', en: 'Cameroon', de: 'Kamerun' },
    { code: 'CN', en: 'China', de: 'China' },
    { code: 'CO', en: 'Colombia', de: 'Kolumbien' },
    { code: 'CR', en: 'Costa Rica', de: 'Costa Rica' },
    { code: 'CU', en: 'Cuba', de: 'Kuba' },
    { code: 'CV', en: 'Cabo Verde', de: 'Kap Verde' },
    { code: 'CW', en: 'Curaçao', de: 'Curaçao' },
    { code: 'CX', en: 'Christmas Island', de: 'Weihnachtsinsel' },
    { code: 'CY', en: 'Cyprus', de: 'Zypern' },
    { code: 'CZ', en: 'Czechia', de: 'Tschechien' },
    { code: 'DE', en: 'Germany', de: 'Deutschland' },
    { code: 'DJ', en: 'Djibouti', de: 'Dschibuti' },
    { code: 'DK', en: 'Denmark', de: 'Dänemark' },
    { code: 'DM', en: 'Dominica', de: 'Dominica' },
    { code: 'DO', en: 'Dominican Republic', de: 'Dominikanische Republik' },
    { code: 'DZ', en: 'Algeria', de: 'Algerien' },
    { code: 'EC', en: 'Ecuador', de: 'Ecuador' },
    { code: 'EE', en: 'Estonia', de: 'Estland' },
    { code: 'EG', en: 'Egypt', de: 'Ägypten' },
    { code: 'EH', en: 'Western Sahara', de: 'Westsahara' },
    { code: 'ER', en: 'Eritrea', de: 'Eritrea' },
    { code: 'ES', en: 'Spain', de: 'Spanien' },
    { code: 'ET', en: 'Ethiopia', de: 'Äthiopien' },
    { code: 'FI', en: 'Finland', de: 'Finnland' },
    { code: 'FJ', en: 'Fiji', de: 'Fidschi' },
    { code: 'FK', en: 'Falkland Islands', de: 'Falklandinseln' },
    { code: 'FM', en: 'Micronesia', de: 'Mikronesien' },
    { code: 'FO', en: 'Faroe Islands', de: 'Färöer' },
    { code: 'FR', en: 'France', de: 'Frankreich' },
    { code: 'GA', en: 'Gabon', de: 'Gabun' },
    { code: 'GB', en: 'United Kingdom', de: 'Vereinigtes Königreich' },
    { code: 'GD', en: 'Grenada', de: 'Grenada' },
    { code: 'GE', en: 'Georgia', de: 'Georgien' },
    { code: 'GF', en: 'French Guiana', de: 'Französisch-Guayana' },
    { code: 'GG', en: 'Guernsey', de: 'Guernsey' },
    { code: 'GH', en: 'Ghana', de: 'Ghana' },
    { code: 'GI', en: 'Gibraltar', de: 'Gibraltar' },
    { code: 'GL', en: 'Greenland', de: 'Grönland' },
    { code: 'GM', en: 'Gambia', de: 'Gambia' },
    { code: 'GN', en: 'Guinea', de: 'Guinea' },
    { code: 'GP', en: 'Guadeloupe', de: 'Guadeloupe' },
    { code: 'GQ', en: 'Equatorial Guinea', de: 'Äquatorialguinea' },
    { code: 'GR', en: 'Greece', de: 'Griechenland' },
    {
        code: 'GS',
        en: 'South Georgia and the South Sandwich Islands',
        de: 'Südgeorgien und die Südlichen Sandwichinseln',
    },
    { code: 'GT', en: 'Guatemala', de: 'Guatemala' },
    { code: 'GU', en: 'Guam', de: 'Guam' },
    { code: 'GW', en: 'Guinea-Bissau', de: 'Guinea-Bissau' },
    { code: 'GY', en: 'Guyana', de: 'Guyana' },
    { code: 'HK', en: 'Hong Kong', de: 'Hongkong' },
    { code: 'HM', en: 'Heard Island and McDonald Islands', de: 'Heard und McDonaldinseln' },
    { code: 'HN', en: 'Honduras', de: 'Honduras' },
    { code: 'HR', en: 'Croatia', de: 'Kroatien' },
    { code: 'HT', en: 'Haiti', de: 'Haiti' },
    { code: 'HU', en: 'Hungary', de: 'Ungarn' },
    { code: 'ID', en: 'Indonesia', de: 'Indonesien' },
    { code: 'IE', en: 'Ireland', de: 'Irland' },
    { code: 'IL', en: 'Israel', de: 'Israel' },
    { code: 'IM', en: 'Isle of Man', de: 'Isle of Man' },
    { code: 'IN', en: 'India', de: 'Indien' },
    {
        code: 'IO',
        en: 'British Indian Ocean Territory',
        de: 'Britisches Territorium im Indischen Ozean',
    },
    { code: 'IQ', en: 'Iraq', de: 'Irak' },
    { code: 'IR', en: 'Iran', de: 'Iran' },
    { code: 'IS', en: 'Iceland', de: 'Island' },
    { code: 'IT', en: 'Italy', de: 'Italien' },
    { code: 'JE', en: 'Jersey', de: 'Jersey' },
    { code: 'JM', en: 'Jamaica', de: 'Jamaika' },
    { code: 'JO', en: 'Jordan', de: 'Jordanien' },
    { code: 'JP', en: 'Japan', de: 'Japan' },
    { code: 'KE', en: 'Kenya', de: 'Kenia' },
    { code: 'KG', en: 'Kyrgyzstan', de: 'Kirgisistan' },
    { code: 'KH', en: 'Cambodia', de: 'Kambodscha' },
    { code: 'KI', en: 'Kiribati', de: 'Kiribati' },
    { code: 'KM', en: 'Comoros', de: 'Komoren' },
    { code: 'KN', en: 'Saint Kitts and Nevis', de: 'St. Kitts und Nevis' },
    { code: 'KP', en: 'North Korea', de: 'Nordkorea' },
    { code: 'KR', en: 'South Korea', de: 'Südkorea' },
    { code: 'KW', en: 'Kuwait', de: 'Kuwait' },
    { code: 'KY', en: 'Cayman Islands', de: 'Kaimaninseln' },
    { code: 'KZ', en: 'Kazakhstan', de: 'Kasachstan' },
    { code: 'LA', en: 'Laos', de: 'Laos' },
    { code: 'LB', en: 'Lebanon', de: 'Libanon' },
    { code: 'LC', en: 'Saint Lucia', de: 'St. Lucia' },
    { code: 'LI', en: 'Liechtenstein', de: 'Liechtenstein' },
    { code: 'LK', en: 'Sri Lanka', de: 'Sri Lanka' },
    { code: 'LR', en: 'Liberia', de: 'Liberia' },
    { code: 'LS', en: 'Lesotho', de: 'Lesotho' },
    { code: 'LT', en: 'Lithuania', de: 'Litauen' },
    { code: 'LU', en: 'Luxembourg', de: 'Luxemburg' },
    { code: 'LV', en: 'Latvia', de: 'Lettland' },
    { code: 'LY', en: 'Libya', de: 'Libyen' },
    { code: 'MA', en: 'Morocco', de: 'Marokko' },
    { code: 'MC', en: 'Monaco', de: 'Monaco' },
    { code: 'MD', en: 'Moldova', de: 'Moldau' },
    { code: 'ME', en: 'Montenegro', de: 'Montenegro' },
    { code: 'MF', en: 'Saint Martin', de: 'Saint-Martin' },
    { code: 'MG', en: 'Madagascar', de: 'Madagaskar' },
    { code: 'MH', en: 'Marshall Islands', de: 'Marshallinseln' },
    { code: 'MK', en: 'North Macedonia', de: 'Nordmazedonien' },
    { code: 'ML', en: 'Mali', de: 'Mali' },
    { code: 'MM', en: 'Myanmar', de: 'Myanmar' },
    { code: 'MN', en: 'Mongolia', de: 'Mongolei' },
    { code: 'MO', en: 'Macao', de: 'Macau' },
    { code: 'MP', en: 'Northern Mariana Islands', de: 'Nördliche Marianen' },
    { code: 'MQ', en: 'Martinique', de: 'Martinique' },
    { code: 'MR', en: 'Mauritania', de: 'Mauretanien' },
    { code: 'MS', en: 'Montserrat', de: 'Montserrat' },
    { code: 'MT', en: 'Malta', de: 'Malta' },
    { code: 'MU', en: 'Mauritius', de: 'Mauritius' },
    { code: 'MV', en: 'Maldives', de: 'Malediven' },
    { code: 'MW', en: 'Malawi', de: 'Malawi' },
    { code: 'MX', en: 'Mexico', de: 'Mexiko' },
    { code: 'MY', en: 'Malaysia', de: 'Malaysia' },
    { code: 'MZ', en: 'Mozambique', de: 'Mosambik' },
    { code: 'NA', en: 'Namibia', de: 'Namibia' },
    { code: 'NC', en: 'New Caledonia', de: 'Neukaledonien' },
    { code: 'NE', en: 'Niger', de: 'Niger' },
    { code: 'NF', en: 'Norfolk Island', de: 'Norfolkinsel' },
    { code: 'NG', en: 'Nigeria', de: 'Nigeria' },
    { code: 'NI', en: 'Nicaragua', de: 'Nicaragua' },
    { code: 'NL', en: 'Netherlands', de: 'Niederlande' },
    { code: 'NO', en: 'Norway', de: 'Norwegen' },
    { code: 'NP', en: 'Nepal', de: 'Nepal' },
    { code: 'NR', en: 'Nauru', de: 'Nauru' },
    { code: 'NU', en: 'Niue', de: 'Niue' },
    { code: 'NZ', en: 'New Zealand', de: 'Neuseeland' },
    { code: 'OM', en: 'Oman', de: 'Oman' },
    { code: 'PA', en: 'Panama', de: 'Panama' },
    { code: 'PE', en: 'Peru', de: 'Peru' },
    { code: 'PF', en: 'French Polynesia', de: 'Französisch-Polynesien' },
    { code: 'PG', en: 'Papua New Guinea', de: 'Papua-Neuguinea' },
    { code: 'PH', en: 'Philippines', de: 'Philippinen' },
    { code: 'PK', en: 'Pakistan', de: 'Pakistan' },
    { code: 'PL', en: 'Poland', de: 'Polen' },
    { code: 'PM', en: 'Saint Pierre and Miquelon', de: 'Saint-Pierre und Miquelon' },
    { code: 'PN', en: 'Pitcairn Islands', de: 'Pitcairninseln' },
    { code: 'PR', en: 'Puerto Rico', de: 'Puerto Rico' },
    { code: 'PS', en: 'Palestine', de: 'Palästina' },
    { code: 'PT', en: 'Portugal', de: 'Portugal' },
    { code: 'PW', en: 'Palau', de: 'Palau' },
    { code: 'PY', en: 'Paraguay', de: 'Paraguay' },
    { code: 'QA', en: 'Qatar', de: 'Katar' },
    { code: 'RE', en: 'Réunion', de: 'Réunion' },
    { code: 'RO', en: 'Romania', de: 'Rumänien' },
    { code: 'RS', en: 'Serbia', de: 'Serbien' },
    { code: 'RU', en: 'Russia', de: 'Russland' },
    { code: 'RW', en: 'Rwanda', de: 'Ruanda' },
    { code: 'SA', en: 'Saudi Arabia', de: 'Saudi-Arabien' },
    { code: 'SB', en: 'Solomon Islands', de: 'Salomonen' },
    { code: 'SC', en: 'Seychelles', de: 'Seychellen' },
    { code: 'SD', en: 'Sudan', de: 'Sudan' },
    { code: 'SE', en: 'Sweden', de: 'Schweden' },
    { code: 'SG', en: 'Singapore', de: 'Singapur' },
    { code: 'SH', en: 'Saint Helena', de: 'St. Helena' },
    { code: 'SI', en: 'Slovenia', de: 'Slowenien' },
    { code: 'SJ', en: 'Svalbard and Jan Mayen', de: 'Spitzbergen und Jan Mayen' },
    { code: 'SK', en: 'Slovakia', de: 'Slowakei' },
    { code: 'SL', en: 'Sierra Leone', de: 'Sierra Leone' },
    { code: 'SM', en: 'San Marino', de: 'San Marino' },
    { code: 'SN', en: 'Senegal', de: 'Senegal' },
    { code: 'SO', en: 'Somalia', de: 'Somalia' },
    { code: 'SR', en: 'Suriname', de: 'Suriname' },
    { code: 'SS', en: 'South Sudan', de: 'Südsudan' },
    { code: 'ST', en: 'São Tomé and Príncipe', de: 'São Tomé und Príncipe' },
    { code: 'SV', en: 'El Salvador', de: 'El Salvador' },
    { code: 'SX', en: 'Sint Maarten', de: 'Sint Maarten' },
    { code: 'SY', en: 'Syria', de: 'Syrien' },
    { code: 'SZ', en: 'Eswatini', de: 'Eswatini' },
    { code: 'TC', en: 'Turks and Caicos Islands', de: 'Turks- und Caicosinseln' },
    { code: 'TD', en: 'Chad', de: 'Tschad' },
    { code: 'TF', en: 'French Southern Territories', de: 'Französische Süd- und Antarktisgebiete' },
    { code: 'TG', en: 'Togo', de: 'Togo' },
    { code: 'TH', en: 'Thailand', de: 'Thailand' },
    { code: 'TJ', en: 'Tajikistan', de: 'Tadschikistan' },
    { code: 'TK', en: 'Tokelau', de: 'Tokelau' },
    { code: 'TL', en: 'Timor-Leste', de: 'Timor-Leste' },
    { code: 'TM', en: 'Turkmenistan', de: 'Turkmenistan' },
    { code: 'TN', en: 'Tunisia', de: 'Tunesien' },
    { code: 'TO', en: 'Tonga', de: 'Tonga' },
    { code: 'TR', en: 'Turkey', de: 'Türkei' },
    { code: 'TT', en: 'Trinidad and Tobago', de: 'Trinidad und Tobago' },
    { code: 'TV', en: 'Tuvalu', de: 'Tuvalu' },
    { code: 'TW', en: 'Taiwan', de: 'Taiwan' },
    { code: 'TZ', en: 'Tanzania', de: 'Tansania' },
    { code: 'UA', en: 'Ukraine', de: 'Ukraine' },
    { code: 'UG', en: 'Uganda', de: 'Uganda' },
    {
        code: 'UM',
        en: 'United States Minor Outlying Islands',
        de: 'Kleinere Amerikanische Überseeinseln',
    },
    { code: 'US', en: 'United States', de: 'Vereinigte Staaten' },
    { code: 'UY', en: 'Uruguay', de: 'Uruguay' },
    { code: 'UZ', en: 'Uzbekistan', de: 'Usbekistan' },
    { code: 'VA', en: 'Vatican City', de: 'Vatikanstadt' },
    { code: 'VC', en: 'Saint Vincent and the Grenadines', de: 'St. Vincent und die Grenadinen' },
    { code: 'VE', en: 'Venezuela', de: 'Venezuela' },
    { code: 'VG', en: 'British Virgin Islands', de: 'Britische Jungferninseln' },
    { code: 'VI', en: 'United States Virgin Islands', de: 'Amerikanische Jungferninseln' },
    { code: 'VN', en: 'Vietnam', de: 'Vietnam' },
    { code: 'VU', en: 'Vanuatu', de: 'Vanuatu' },
    { code: 'WF', en: 'Wallis and Futuna', de: 'Wallis und Futuna' },
    { code: 'WS', en: 'Samoa', de: 'Samoa' },
    { code: 'YE', en: 'Yemen', de: 'Jemen' },
    { code: 'YT', en: 'Mayotte', de: 'Mayotte' },
    { code: 'ZA', en: 'South Africa', de: 'Südafrika' },
    { code: 'ZM', en: 'Zambia', de: 'Sambia' },
    { code: 'ZW', en: 'Zimbabwe', de: 'Simbabwe' },
];
// Lookup map keyed by uppercase ISO code for O(1) access.
const countryMap = new Map(countries.map((c) => [c.code, c]));
/**
 * Returns the country name for a given ISO code and locale ('en' | 'de').
 * Falls back to the raw code if unknown.
 */
export function getCountryName(code, locale) {
    const lang = (locale ||
        (typeof settings !== 'undefined' && settings.languageCode) ||
        'en').toLowerCase();
    const entry = countryMap.get((code || '').toUpperCase());
    if (!entry)
        return code;
    return lang.startsWith('de') ? entry.de : entry.en;
}
